/*
 * @Author: 向南星 xiangnanxing@scmagic.cn
 * @Date: 2022-11-02 14:48:35
 * @LastEditors: 向南星 xiangnanxing@scmagic.cn
 * @LastEditTime: 2022-11-08 10:45:01
 */
import { Toast } from '@easyvaas/js-components';
import classNames from 'classnames';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useRecoilCallback, useRecoilValue } from 'recoil';
import { composeJewel, imagesV3Data } from '../../services';
import { jewelItemSelector, materialItemSelector } from '../../store/selector';
import { imagePopupState } from '../../store/state';
import ImageOperationPopup from '../ImageOpreationPopup';
import NumberInput from '../NumberInput';
import styles from './index.module.scss';

const getSuccessTips = (type: ImageV3API.MaterialType) => {
  switch (type) {
    case 2:
      return '合成洗髓丹成功，可在我的座驾页面查看重置座驾技能';
    case 3:
      return '合成高级洗髓丹成功，可在我的座驾页面查看重置座驾高级技能';
    case 4:
      return '合成进阶卡成功，可在我的座驾页面使用进阶卡进阶座驾';
    case 5:
      return '合成九花玉露成功，可在我的座驾页面查看重置座驾属性';
    case 9:
      return '合成宠物口粮成功，可在我的座驾页面为座驾升星';
    default:
      return '';
  }
};

const JewelItem = React.memo(
  ({ piecesType, number }: ImageV3API.ComposeItem) => {
    const jewel = useRecoilValue(jewelItemSelector(piecesType));
    if (!jewel) return null;
    return (
      <div className={styles.jewel}>
        <img src={jewel.logo} alt="" />
        <div className={styles.name}>{jewel.title}</div>
        <div
          className={classNames(
            styles.number,
            number > jewel.number && styles.accent
          )}
        >
          {number}/{jewel.number}
        </div>
      </div>
    );
  }
);
const PropComposePopup = () => {
  const { target, visible } = useRecoilValue(imagePopupState('propCompose'));
  const item = useRecoilValue(materialItemSelector(target));
  const [number, setNumber] = useState('1');
  const [max, setMax] = useState(1);
  const [success, setSuccess] = useState(false);
  const onCompose = useRecoilCallback(({ set }) => async () => {
    try {
      if (!item) return;
      const count = Number(number);
      if (count <= 0) return;
      Toast.loading('合成中...');
      await composeJewel({
        toolId: item.toolId,
        number: count
      });
      await imagesV3Data.refresh({});
      Toast.hide();
      setSuccess(true);
      updateMax();
    } catch ({ message }) {
      Toast(message);
    }
  });

  const updateMax = useRecoilCallback(
    ({ snapshot }) => async () => {
      if (!item || item.composeList.length === 0) {
        setMax(1);
        return;
      }
      let maxTemp: number | null = null;
      for (let i = 0; i < item.composeList.length; i += 1) {
        const { piecesType, number } = item.composeList[i];
        const jewel = await snapshot.getPromise(jewelItemSelector(piecesType));
        if (!jewel) continue;
        const count = Math.floor(jewel.number / Number(number));
        if (maxTemp === null || count < maxTemp) {
          maxTemp = count;
        }
      }
      setMax((maxTemp || 0) + 1);
    },
    [item]
  );

  const reset = useCallback(() => {
    setNumber('1');
    setSuccess(false);
  }, []);

  //初始化弹窗内部状态
  useEffect(() => {
    if (!visible) {
      setTimeout(() => {
        reset();
      }, 300);
    }
  }, [reset, visible]);

  useEffect(() => {
    updateMax();
  }, [updateMax]);

  const disable = useMemo(() => {
    return Number(number) === max && !success;
  }, [number, max, success]);

  if (!item) return null;
  return (
    <ImageOperationPopup
      className={styles.container}
      type="propCompose"
      title="材料合成"
      position="bottom"
      onClick={disable ? undefined : success ? reset : onCompose}
      confirmText={success ? '继续合成' : '合成'}
      cancelText={success ? '返回' : '取消'}
    >
      <div className={styles.info}>
        <img className={styles.logo} src={item.logo} alt="" />
        <div className={styles.name}>{item.title}</div>
        <div className={styles.desc}>{item.desc}</div>
      </div>
      {success ? (
        <div className={styles.success}>
          <div className={styles.title}>合成成功</div>
          <img src={item.logo} alt="" />
          <div className={styles.desc}>
            <span>{item.title}</span>x{number}
          </div>
          <div className={styles.successTips}>
            <span>{getSuccessTips(item.type)}</span>
          </div>
        </div>
      ) : (
        <>
          <div className={styles.field}>
            <div className={styles.label}>合成数量</div>
            <NumberInput value={number} onChange={setNumber} max={max} />
          </div>

          <div className={styles.field}>
            <div className={styles.label}>合成所需</div>
            <div className={styles.jewels}>
              {item.composeList.map(v => (
                <JewelItem
                  key={v.piecesType}
                  piecesType={v.piecesType}
                  number={Number(number) * v.number}
                />
              ))}
            </div>
          </div>
        </>
      )}

      {disable && (
        <div className={styles.tips}>
          <div>
            材料不足，请参与APP 内活动获得
            <br />
            红宝石：打赏礼物概率掉落
            <br />
            黄宝石：开通守护概率掉落
            <br />
            绿宝石：完成心愿概率掉落
            <br />
            蓝宝石：玩直播间转盘概率掉落
          </div>
        </div>
      )}
    </ImageOperationPopup>
  );
};

export default React.memo(PropComposePopup);
